var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    className: "bob-core-components-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "icons/_tint/document"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 18.5h-3c-.85 0-1.5-.65-1.5-1.5V6.5c0-.85.65-1.5 1.5-1.5H15v12c0 .85-.65 1.5-1.5 1.5z",
    className: "secondarytint"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.75 1c-.55 0-1.05.3-1.4.7 0 .05-.05.05-.05.1-.2.3-.3.6-.3.95V5h3.5V2.75c0-.95-.8-1.75-1.75-1.75z",
    className: "tertiarytint"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 2H5.85C4.25 2 3 3.3 3 4.85v14.3C3 20.75 4.3 22 5.85 22h8.3c1.6 0 2.85-1.3 2.85-2.85V7h4V4.5C21 3.1 19.9 2 18.5 2zm-2.1 1.15c-.25.35-.4.85-.4 1.35v14.65c0 1-.85 1.85-1.85 1.85h-8.3c-1 0-1.85-.85-1.85-1.85V4.85C4 3.85 4.85 3 5.85 3H16.5c0 .05-.05.1-.1.15zM20 6h-3V4.5c0-.85.65-1.5 1.5-1.5s1.5.65 1.5 1.5V6zm-5.5 1.5c0 .3-.2.5-.5.5H6c-.3 0-.5-.2-.5-.5S5.7 7 6 7h8c.3 0 .5.2.5.5zm-3 6c0 .3-.2.5-.5.5H6c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h5c.3 0 .5.2.5.5zm3-2c0 .3-.2.5-.5.5H6c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h8c.3 0 .5.2.5.5zm0-2c0 .3-.2.5-.5.5H6c-.3 0-.5-.2-.5-.5S5.7 9 6 9h8c.3 0 .5.2.5.5z",
    className: "primarytint"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.2cbefabbf7f8414c8bdba570fc750db8.svg";
export { ForwardRef as ReactComponent };